<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
        <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
            <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentMail">
              <div style="width: 100px; padding-left: 10px; height: 50px">
                <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer" svg-classes="w-6 h-6"></feather-icon>
              </div>

                <component :is="scrollbarTag" class="md:px-8 md:pb-8 pt-4 px-6 pb-6" style="height: 100%" :settings="settings" :key="$vs.rtl">

                <br>

                <div v-if="isSidebarActive">
                    <!-- LATEST MESSAGE -->
                    <div class="vx-row">
                        <div class="vx-col w-full">
                          <email-mail-card :mailContent="currentMail" />
                        </div>
                    </div>

                    <div class="vx-row mb-10" style="margin-top: 2.2rem">
                        <div class="vx-col w-full">
                            <vx-card>
                                <div class="vx-row">
                                    <div class="vx-col w-full flex justify-between">
                                      <br/>
                                      <br/>
                                      <div class="center">
                                        <vs-button v-if="(activeUserInfo.userRole === 'OWNER_ADMIN' || activeUserInfo.userRole === 'SUPER_ADMIN') &&  this.currentMail.status !== 'COMPLETED' && this.currentMail.status === 'ACCEPTED'" color="success" v-on:click="confirmComplete" class="m-2">
                                         Завершить
                                        </vs-button>
                                        <vs-button v-if="this.currentMail.status !== 'COMPLETED' && this.currentMail.status !== 'ACCEPTED'" color="success" v-on:click="confirmApprove" class="m-2">
                                          Принимать
                                        </vs-button>
                                        <vs-button v-if="this.currentMail.status !== 'COMPLETED' && this.currentMail.status !== 'NOT_ACCEPTED'" color="warning" v-on:click="confirmCancel" class="m-2">
                                          Отказать
                                        </vs-button>
                                        <vs-button v-on:click="confirmSendMessage" class="m-2">
                                          Отправить писмо
                                        </vs-button>
                                      </div>
                                      <div v-if="this.currentMail.status !== 'COMPLETED'" class="center mt2">
                                        <vs-button v-on:click="reUploadMessage" class="m-2" color="danger">
                                          Отправить ссылку для повторной загрузки файла
                                        </vs-button>
                                        <vs-button v-if="(activeUserInfo.userRole === 'OWNER_ADMIN' || activeUserInfo.userRole === 'SUPER_ADMIN') && this.currentMail.status === 'ACCEPTED' && currentMail.payment_status !== 'SENT' && currentMail.payment_status !== 'UNPAID' && !currentMail.payment_link" v-on:click="paymentMessage" class="m-2">
                                          Отправить ссылку для оплаты
                                        </vs-button>

                                        <vs-button v-if="(activeUserInfo.userRole === 'OWNER_ADMIN' || activeUserInfo.userRole === 'SUPER_ADMIN') && this.currentMail.status === 'ACCEPTED' && currentMail.payment_status !== 'PAID'" color="primary" v-on:click="confirmPayment" class="m-2">
                                          Отметит как оплаченный
                                        </vs-button>

                                        <vs-button color="danger" v-on:click="confirmFail" class="m-2">
                                          Есть технические ошибки
                                        </vs-button>
                                      </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>

                  <br/>
                  <vx-card style="min-height: 800px">
                    <h5>Посмотреть файл:</h5>
                    <iframe width="100%" height="800px" :src="`https://view.officeapps.live.com/op/view.aspx?src=https://api.conferences-list.uz/storage/${ this.currentMail.file}`"></iframe>
                  </vx-card>
                  <br/>
                </div>
                </component>
            </div>
        </vs-sidebar>
        <vs-popup title="Отправить писмо" :active.sync="sendEmail.active">

          <div class="col">
            <br>
            <vs-input class="col-sm-12 full-width" v-model="sendEmail.email" placeholder="Email"></vs-input>
            <br>
            <vs-textarea class="col-sm-12 full-width" type="textarea" v-model="sendEmail.text" placeholder="Text">
            </vs-textarea>
            <vs-button class="mt-2" color="primary" @click="sendMessage">Отправить</vs-button>
          </div>
        </vs-popup>
        <vs-popup title="Вы уверены?" :active.sync="cancelModal">

          <div class="col">
            <vs-textarea class="col-sm-12 full-width" type="textarea" v-model="sendEmail.answer_text" placeholder="Причина отменить заявку участника">
            </vs-textarea>
            <vs-button class="mt-2 mr-2" color="warning" @click="cancel">Да</vs-button>
            <vs-button class="mt-2" color="primary" @click="cancelModal = false">Нет</vs-button>
          </div>
        </vs-popup>
        <vs-popup title="Отправить ссылку для повторной загрузки файла: Вы уверены?" :active.sync="reUploadModal">

          <div class="col">
            <vs-textarea class="col-sm-12 full-width" type="textarea" v-model="sendEmail.answer_text" placeholder="Сообщение об исправление для участника">
            </vs-textarea>
            <vs-button class="mt-2 mr-2" color="warning" @click="reUpload">Да</vs-button>
            <vs-button class="mt-2" color="primary" @click="reUploadModal = false">Нет</vs-button>
          </div>
        </vs-popup>
        <vs-popup title="Отправить ссылку для оплаты: Вы уверены?" :active.sync="paymentModal">

          <div class="col">
            <vs-textarea class="col-sm-12 full-width" type="textarea" v-model="sendEmail.answer_text" placeholder="Ссылка для оплаты">
            </vs-textarea>
            <vs-button class="mt-2 mr-2" color="warning" @click="paymentSent">Да</vs-button>
            <vs-button class="mt-2" color="primary" @click="paymentModal = false">Нет</vs-button>
          </div>
        </vs-popup>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmailMailCard from './EmailMailCard.vue'
import axios from '@/axios.js'

export default {
  props: {
    emailTags: {
      type: Array,
      required: false
    },
    openMailId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    mailFilter: {
      type: String
    }
  },
  data () {
    return {
      sendEmail: {
        email: '',
        text: '',
        answer_text: '',
        active: false
      },
      cancelModal: false,
      reUploadModal: false,
      paymentModal: false,
      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50
      }
    }
  },
  watch: {
    isSidebarActive (value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    cancelModal (val) {
      if (val === false) {
        this.sendEmail.text = ''
        this.sendEmail.email = ''
        this.sendEmail.answer_text = ''
        this.sendEmail.active = false
      }
    },
    reUploadModal (val) {
      if (val === false) {
        this.sendEmail.text = ''
        this.sendEmail.email = ''
        this.sendEmail.answer_text = ''
        this.sendEmail.active = false
      }
    },
    paymentModal (val) {
      if (val === false) {
        this.sendEmail.text = ''
        this.sendEmail.email = ''
        this.sendEmail.answer_text = ''
        this.sendEmail.active = false
      }
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentMail () {
      return this.$store.getters['email/getMail'](this.openMailId)
    },
    labelColor () {
      return (label) => {
        const tags = this.$store.state.email.mailTags
        return tags.find((tag) => {
          return tag.value === label
        }).color
      }
    },
    currentMailLabels: {
      get () {
        return []
      },
      set (value) {
        if (Array.isArray(value)) {
          const payload = { mailId: this.openMailId, labels: value }
          this.$store.dispatch('email/setLabels', payload)
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    toggleIsStarred () {
      const payload = { mailId: this.openMailId, value: !this.currentMail.isStarred }
      this.$store.dispatch('email/toggleIsMailStarred', payload)
    },
    moveTo (to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    },
    confirmApprove () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Принимать',
        text: 'Вы уверены, что подвердить',
        accept: this.accept,
        acceptText: 'Да',
        cancelText: 'Нет'
      })
    },
    confirmComplete () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Завершить',
        text: 'Вы уверены, что завершить',
        accept: this.complete,
        acceptText: 'Да',
        cancelText: 'Нет'
      })
    },
    confirmFail () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Принимать',
        text: 'Вы уверены, что отменит как тех. ошибки',
        accept: this.fail,
        acceptText: 'Да',
        cancelText: 'Нет'
      })
    },
    confirmPayment () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Подвердить оплату',
        text: 'Вы уверены, что подвердить',
        accept: this.acceptPayment,
        acceptText: 'Да',
        cancelText: 'Нет'
      })
    },
    confirmCancel () {
      this.cancelModal = true
    },
    reUploadMessage () {
      this.reUploadModal = true
    },
    paymentMessage () {
      this.paymentModal = true
    },
    confirmSendMessage () {
      this.sendEmail.email = this.currentMail.email
      this.sendEmail.active = true
    },
    sendMessage () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/send-message', {email: this.currentMail.email, text: this.sendEmail.text})
          .then((response) => {
            this.sendEmail.text = ''
            this.sendEmail.email = ''
            this.sendEmail.answer_text = ''

            this.sendEmail.active = false
            this.$vs.notify({
              title: 'Успешно отправлено',
              text: 'Отправлено',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    accept () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/approve', {id: this.currentMail.id})
          .then((response) => {

            // Convert Date String to Date Object
            const event = response.data.data
            if ('ACCEPTED' === event.status) {
              this.$vs.notify({
                title: 'Успешно принято',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.status = 'ACCEPTED'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    complete () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/complete', {id: this.currentMail.id})
          .then((response) => {

            // Convert Date String to Date Object
            const event = response.data.data
            if ('COMPLETED' === event.status) {
              this.$vs.notify({
                title: 'Успешно завершен',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.status = 'COMPLETED'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fail () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/fail', {id: this.currentMail.id})
          .then((response) => {

            // Convert Date String to Date Object
            const event = response.data.data
            if ('FAIL' === event.status) {
              this.$vs.notify({
                title: 'Успешно обновлено',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.status = 'FAIL'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    acceptPayment () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/accept-payment', {id: this.currentMail.id})
          .then((response) => {

            // Convert Date String to Date Object
            const event = response.data.data
            if ('PAID' === event.payment_status) {
              this.$vs.notify({
                title: 'Успешно принято',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.payment_status = 'PAID'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    cancel () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/cancel', {id: this.currentMail.id, answer_text: this.sendEmail.answer_text})
          .then((response) => {
            this.sendEmail.text = ''
            this.sendEmail.email = ''
            this.sendEmail.answer_text = ''
            this.sendEmail.active = false
            // Convert Date String to Date Object
            const event = response.data.data
            this.cancelModal = false
            if ('NOT_ACCEPTED' === event.status) {
              this.$vs.notify({
                title: 'Успешно отменено',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.status = 'NOT_ACCEPTED'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    reUpload () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/re-upload', {id: this.currentMail.id, text: this.sendEmail.answer_text})
          .then((response) => {
            this.sendEmail.text = ''
            this.sendEmail.email = ''
            this.sendEmail.answer_text = ''
            this.sendEmail.active = false
            // Convert Date String to Date Object
            const event = response.data.data
            this.reUploadModal = false
            if ('RE_UPLOAD' === event.status) {
              this.$vs.notify({
                title: 'Успешно отпралено',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.status = 'RE_UPLOAD'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })

    },
    paymentSent () {
      return new Promise((resolve, reject) => {
        axios.post('https://api.conferences-list.uz/api/v1/requests/payment-sent', {id: this.currentMail.id, text: this.sendEmail.answer_text})
          .then((response) => {

            // Convert Date String to Date Object
            const event = response.data.data
            this.paymentModal = false
            if ('SENT' === event.payment_status) {
              this.$vs.notify({
                title: 'Успешно отправлено',
                text: 'Принято',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.currentMail.payment_status = 'SENT'
            } else {
              this.$vs.notify({
                title: 'Не обновлено',
                text: '-',
                color: 'danger',
                iconPack: 'feather'
              })
            }
            this.currentMail.payment_link = event.payment_link

            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    EmailMailCard
  },
  updated () {
    if (!this.currentMail) return
    if (this.currentMail.unread && this.isSidebarActive) this.$store.dispatch('email/setUnread', { emailIds: [this.openMailId], unread: false })
  }
}

</script>

